import { Box, Grid } from "@mui/material";
import AccidentPopup from "../../components/Fleet/Accident/AccidentPopup/AccidentPopup";
import AccidentsTable from "../../components/Fleet/Accident/AccidentsTable/AccidentsTable";
import QuickAccidentPopup from "../../components/Fleet/Accident/QuickAccidentPopup/QuickAccidentPopup";

const AccidentsPage = () => {
  return (
    <Box className="accidents-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <AccidentPopup />
              </Grid>
              <Grid item>
                <QuickAccidentPopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <AccidentsTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AccidentsPage;
